import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from "@angular/core";
import {
  DashboardLayoutComponent as ZDashboardLayoutComponent,
  EDashboardLayout
} from "@zaeper/angular-dashboard-view-lib";
import { Subscription } from "rxjs";
import { IMenuItem, MenuItemCommand, MenuItemRouterLink } from "@zaeper/core-lib";
import { UserMenuComponent } from "../../menus/user-menu/user-menu.component";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";
import { DarkModeToggleComponent } from "@zaeper/angular-dashboard-view-lib";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";
import {
  appSwitcherModalServiceInjectionToken
} from "../../modals/app-switcher-modal/app-switcher-modal-service-injection-token";
import { AppSwitcherModalService } from "../../modals/app-switcher-modal/app-switcher-modal.service";
import { IAppSwitcherModalService } from "../../modals/app-switcher-modal/i-app-switcher-modal.service";

@Component( {
  selector: "app-dashboard-layout",
  templateUrl: "./dashboard-layout.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ZTemplateDirective, ZDashboardLayoutComponent, UserMenuComponent, DarkModeToggleComponent, ButtonModule, TooltipModule
  ],
  providers: [
    {
      provide: appSwitcherModalServiceInjectionToken,
      useClass: AppSwitcherModalService
    }
  ]
} )
export class DashboardLayoutComponent implements OnDestroy {
  @Input( "routerPath" ) public routerPath: string = "";

  public readonly dashboardLayout: EDashboardLayout = EDashboardLayout.BLOCKS;
  public readonly navItems: IMenuItem[] = [
    new MenuItemRouterLink( {
      icon: "home",
      title: "home",
      internalLink: `/de/`
    } ), new MenuItemRouterLink( {
      icon: "apps",
      title: "applications",
      internalLink: `/de/applications`
    } ), new MenuItemRouterLink( {
      icon: "share",
      title: "repositories",
      internalLink: `/de/repositories`
    } ), new MenuItemCommand( {
      icon: "info_outline",
      title: "infos",
      command: () => {
        //this._openModal(InfoModalComponent, 'Infos', '500px'),
      }
    } )
  ];
  private readonly _subscriptions: Subscription = new Subscription();

  constructor(
    @Inject( appSwitcherModalServiceInjectionToken ) private readonly _appSwitcherModalService: IAppSwitcherModalService
  ) {
  }

  public openAppSwitcher(): void {
    this._appSwitcherModalService.open();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
